import React, {useState} from "react";
import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";

import './index.css'

import Logo1 from "../../images/logo.png";
import LoginImage from "../../images/login-image.jpg";
import procmartLogo from "../../images/pm_logo.png"

import VerifyOtp from "./components/verifyOtp";
import LoginForm from "./components/login";


const Login = () =>{
    const [ toggleForm, setToggleForm ] = useState(false)
    const [ userDetails, setuserDetails ] = useState('')
    const [hash, setHash] = useState("")

    const jwtToken = useSelector((state) => state.userDetails.jwtToken)
    if(jwtToken){
        
        return <Navigate to="/" />
    }

    const handleLoginToggle = (value) =>{
        setToggleForm(value)
    }

    const handleUserDetails = (value) => {
        setuserDetails(value)
    }
    
    return(
        <div className="login-component overflow-y-hidden">
            <div className="flex flex-column col-12 lg:flex-row lg:col-12 p-0">
                <div className="flex col-12 flex-column lg:h-screen lg:flex-column  lg:col-5 p-0">
                    <div className="flex-order-1 lg:h-screen  surface-800 p-8">
                        <h5 className="text-50 text-2xl">
                            Reduce Inventory Costs, <br/>
                            Consolidate Suppliers and <br/>
                            Improve Operations.
                        </h5>
                        <p className="text-50 mt-3 text-lg">
                            ProcMart is the all-in-one solution for all procurement concerns,
                            including spend analysis, e-sourcing, contract management, 
                            supplier management, and request management, as well as project management.
                        </p>
                        
                    </div>
                    <div className=" flex flex-order-2  lg:h-40rem surface-800 col-12 p-0">
                        <div className="">
                            <img className='col-12 h-30rem p-0' src={LoginImage} alt='login-image' />
                        </div>
                    </div>
                </div>
                <div className=" flex flex-column sm:mt-3 lg:flex-column col-12 lg:col-7">
                    <div className="proc-logo">
                        <img src={procmartLogo} alt="procmart" className="w-15rem max-w-full h-auto mt-3" />
                    </div>
                    { toggleForm ?  <VerifyOtp hash={hash} handleLoginToggle={handleLoginToggle} userDetails={userDetails} setHash={setHash} /> 
                        : <LoginForm handleLoginToggle={handleLoginToggle} setHash={setHash} handleUserDetails={handleUserDetails} userDetails={userDetails}/>}
                </div>
            </div>
        </div>
    )
}

export default Login